import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing4,
  spacing8,
  spacing12,
} from 'approot/shared/styles/spacing.style';
import {
  BaseAutosuggestStylesProps,
  baseAutosuggestStyles,
} from 'approot/shared/styles/autosuggest.style';
import { grey1, purple7 } from 'approot/shared/styles/colours.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { font16 } from 'approot/shared/styles/typography.style';

export const VocabularySearchHelp = styled.div`
  padding: ${rem(spacing8)};
  text-align: center;

  button {
    width: 100%;
  }
`;

export const VocabularySearchContainer = styled.div<BaseAutosuggestStylesProps>`
  ${baseAutosuggestStyles}
  position: relative;
  width: 100%;

  .autosuggest_suggestions_container {
    max-height: ${rem(400)};
  }
`;

export const VocabularyStickySearchButton = styled.div`
  ${flexCentreAlignCss}
  background-color: ${grey1};
  bottom: 0;
  padding: ${rem(spacing8)};
  position: sticky;
  button {
    width: 100%;
  }
`;

export const VocabularySearchContainerField = styled.div`
  width: 100%;
`;

export const VocabularySearchApproved = styled.div`
  ${flexCentreAlignCss}

  background-color: ${purple7};
  border-radius: ${rem(18)};
  display: inline-flex;
  margin-left: ${rem(spacing8)};
  height: ${rem(18)};
  width: ${rem(18)};

  svg {
    fill: ${grey1};
  }
`;

export const VocabularySearchResult = styled.div`
  ${font16}
  margin-bottom: ${rem(spacing4)};
`;

export const VocabularyNotPresent = styled(VocabularySearchResult)`
  padding: ${rem(spacing12)};
`;
